import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای ثبت مصرف و ضایعات (Material Consumption)

این فرم برای ثبت مصرف مواد اولیه (صدور از انبار) و ضایعات حین تولید در سطح ایستگاه کاری طراحی شده است. فرایند مصرف مواد اولیه ارتباط یکپارچه‌ای با بالانس ایستگاه‌های کاری و فرمول تبدیل ضریب مصرف (Lot Conversion) دارد که در ادامه توضیح داده شده‌اند.

## ۱. بالانس ایستگاه و محاسبه باقی‌مانده (Material Balance)
در این فرم، سیستم به‌صورت خودکار بالانس (Station Balance) قطعات در یک لات (Lot) را برای شما محاسبه می‌کند.
- **صادر از انبار (Issued):** مقداری که از انبار به خط تولید تحویل داده شده است.
- **مصرف‌شده (Consumed):** مقداری که تا الان برای این لات در خط مصرف شده.
- **ضایعات (Scrapped):** مقداری که در حین کار دچار ضایعات شده یا دور ریز شده.
- **باقی‌مانده (Remaining):** موجودی باقیمانده قطعه در خط برای ادامه تولید.

> **نکته مهم:** شما در این فرم فقط می‌توانید مقادیر جدید را ثبت کنید (رویکرد Append-Only). برای اصلاح رکوردهای اشتباه، باید یک رکورد تعدیل با مقدار منفی وارد کنید.

## ۲. مد ورود هوشمند (Smart Entry)
در پایین فرم، روی دکمه **«ورود هوشمند (Smart Entry Modal)»** کلیک کنید تا به یک دیالوگ یکپارچه برای ثبت سریع هدایت شوید:
- **ثبت مصرف (Consumption):** میزان مصرف قطعه برای این لات را وارد کنید.
- **ثبت ضایعات (Scrap):** در صورت وجود ضایعات، مقدار آن را به همراه دلیل ضایعات (Scrap Reason) وارد نمایید.
- **تغییر ضریب تبدیل (Lot Conversion Adjustment):** در صورتی که قطعات به دلیل تغییر طراحی یا شرایط خاص، با ضریبی متفاوت از استاندارد BOM مصرف می‌شوند، مقدار انحراف و درخواست تغییر ضریب را در این بخش وارد کنید.

## ۳. کنترل‌های تأییدیه (Workflow Gating)
هر رکوردی که در این فرم ثبت می‌کنید از یک **Workflow** عبور می‌کند:
- **حالت اتوماتیک:** اگر فقط رکورد مصرف عادی باشد و مقدار مصرف از حد مجاز عبور نکند، سند در وضعیت تأییدشده قرار می‌گیرد.
- **نیاز به بررسی کیفی (QC):** اگر در رکورد ثبت‌شده **«ضایعات»** وجود داشته باشد یا **«درخواست تغییر ضریب تبدیل لات»** داده شده باشد، سیستم به‌طور خودکار گردش‌کار را به دپارتمان کنترل کیفیت (QC) هدایت می‌کند. تغییرات ضریب فقط پس از تایید نهایی اعمال می‌شوند.

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
